import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';

import Row from 'components/Common/Row';
import { UIVersionContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';
import AnalyticsContext from 'contexts/AnalyticsContext';
import Button from 'kingpin/atoms/Button';
import Typography from 'kingpin/atoms/Typography';

import { ReactComponent as InfoIcon } from './info.svg';

export const V3_SSO_HELP_URL =
  'https://help.fleetops.com/en/articles/15326577-set-up-single-sign-on-sso-using-microsoft';
export const LEGACY_SSO_HELP_URL =
  'https://help.fleetops.com/en/articles/15327520-legacy-set-up-single-sign-on-sso-using-microsoft';

const Banner = styled.div`
  padding: 16px;
  background-color: var(--color-grey-8);
  border-radius: 8px;
`;

const WhatIsSso = () => {
  const { trackEvent } = useContext(AnalyticsContext);
  const { isV3 } = useContext(UIVersionContext);
  const onLearnMoreClicked = useCallback(() => {
    trackEvent('SSO Configurations - Clicked Learn More');
  }, [trackEvent]);

  return (
    <Banner>
      <Row spaceBetween centerAlign>
        <Row>
          <div style={{ marginRight: 8 }}>
            <InfoIcon style={{ color: 'var(--color-icon-primary)' }} />
          </div>
          <div>
            <div style={{ marginBottom: 4 }}>
              <Typography.Body type="Body 12">What is SSO</Typography.Body>
            </div>
            <div>
              <Typography.Body type="Body 12">
                SSO (Single Sign-On) allows users to use a single set of login
                credentials to access multiple applications or systems.
              </Typography.Body>
            </div>
          </div>
        </Row>
        <div>
          <a
            href={isV3 ? V3_SSO_HELP_URL : LEGACY_SSO_HELP_URL}
            target="_blank"
            rel="noreferrer"
          >
            <Button
              type="Tertiary"
              size="Small"
              onClick={onLearnMoreClicked}
              label="Learn More"
            />
          </a>
        </div>
      </Row>
    </Banner>
  );
};

export default WhatIsSso;
